import { render } from "./scenario-drafts.vue?vue&type=template&id=68f81f8a&ts=true"
import script from "./scenario-drafts.vue?vue&type=script&lang=ts"
export * from "./scenario-drafts.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__